export const FETCH_DASHBOARD_DATA_START = "FETCH_DASHBOARD_DATA_START";
export const FETCH_DASHBOARD_DATA_SUCCESS = "FETCH_DASHBOARD_DATA_SUCCESS";
export const FETCH_DASHBOARD_DATA_FAILURE = "FETCH_DASHBOARD_DATA_FAILURE";
export const SET_LOAN_STATUS = "SET_LOAN_STATUS";
export const SET_DOCUMENT_STATUS = "SET_DOCUMENT_STATUS";
export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const SET_NOTIFICATIONS_READ = "SET_NOTIFICATIONS_READ";
export const SET_CREDIT_MODEL = "SET_CREDIT_MODEL";
export const RESET_DASHBOARD = "RESET_DASHBOARD";
